import React, { useEffect, useState } from "react";
import wadepic from "../../../assets/images/wadepic.png";
import "./BookingDetails.css";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { BookingDescriptionById, cancelBooking } from "../../../redux/slice/authSlice";
import { message } from "antd";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const BookingDetails = () => {
  const { id: bookingId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { bookingDescription, bookingcancel } = useSelector((state) => state.auth);

  const [showCancelMessage, setShowCancelMessage] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [smShow, setSmShow] = useState(false);

  // Fetch booking data when ID or cancel state changes
  useEffect(() => {
    dispatch(BookingDescriptionById(bookingId));
  }, [dispatch, bookingId, bookingcancel]);

  // Handle status display
  useEffect(() => {
    if (bookingDescription?.data?.is_canceled === 0) {
      setShowCancelMessage(false);
    } else {
      setShowCancelMessage(true);
    }
  }, [bookingDescription]);

  // Check if booking can be canceled
  useEffect(() => {
    if (bookingDescription?.data?.start) {
      try {
        const startDate = new Date(bookingDescription.data.start);
        const currentDate = new Date();
        setShowCancel(startDate > currentDate);
      } catch (error) {
        console.error("Invalid date:", error);
      }
    }
  }, [bookingDescription]);

  const convertDateFormat = (inputDateStr) => {
    if (!inputDateStr) return "N/A";
    const originalDate = new Date(inputDateStr);
    const day = originalDate.toLocaleString("en-us", { weekday: "long" });
    const time = originalDate.toLocaleString("en-us", {
      hour: "2-digit",
      minute: "2-digit",
    });
    const month = originalDate.toLocaleString("en-us", { month: "long" });
    const date = originalDate.getDate();

    return `${time} ${day}, ${month} ${date}`;
  };

  const bookingCancelConfirm = async () => {
    try {
      await dispatch(cancelBooking({ booking_id: bookingId }));
      setSmShow(false);
      message.success({
        content: "Your Booking is Cancelled Successfully",
        duration: 3,
      });
    } catch (err) {
      console.error("Error canceling booking:", err);
    }
  };

  useEffect(() => {
  if (bookingDescription?.data?.start) {
    const ExpiryDate = new Date(bookingDescription.data.start);
    const currentDate = new Date();
    setShowCancel(ExpiryDate > currentDate); // upcoming
  }
}, [bookingDescription]);


useEffect(() => {
  if (bookingDescription?.data?.is_canceled === 0) {
    setShowCancelMessage(false);
  } else {
    setShowCancelMessage(true);
  }
}, [bookingDescription]);


  const instructor = bookingDescription?.data?.instructor;
  const packageData = bookingDescription?.data?.package;


  return (
    <section>
      <div className="container booking_detail_Container bg-white das_comp_shdo br-10">
        <div className="page-title-box p-1 pt-md-4 ps-md-4">
          <div className="row align-items-center">
            <div className="d-block text-center d-md-flex mt-2 mb-2 justify-content-between">
              <h6 className="page-title heading_booking_details">Booking Details</h6>
          {bookingDescription?.data?.start && (
  <div>
    {showCancel ? (
      showCancelMessage ? (
        <span className="booking_can_message">Booking Cancelled</span>
      ) : (
        <button className="btn btn-danger" onClick={() => setSmShow(true)}>
          Cancel Booking
        </button>
      )
    ) : (
      <>
        {bookingDescription?.data?.is_feedback === 0 ? (
          <button
            className="btn btn-primary me-2 bg-indigo border-0 rate_instructor_btn"
            onClick={() =>
              navigate(
                `/xcsfvt/auth/dashboard/booking/booking-details/rating/${bookingId.id}`
              )
            }
          >
            Rate Your Instructor
          </button>
        ) : (
          <span className="feedback_done_message">Feedback Sent</span>
        )}
      </>
    )}
  </div>
)}

            </div>
          </div>
        </div>

        <div className="card-body account_detail row p-none p-md-4 pt-md-2">
          {/* Instructor Info */}
          <div className="bg-gray">
            <div className="d-flex gap-20 align-items-center instructor_profilecard_wrappper">
              <div className="acc_img rounded-pill me-3">
                <img
                  src={
                    instructor?.profile_image
                      ? `https://keyzi.com.au/keyzi-admin/public/${instructor.profile_image}`
                      : wadepic
                  }
                  className="booking_detail_image"
                  alt="Instructor"
                />
              </div>
              <div className="acc_detail">
                <h5 className="text-capitalize">{instructor?.name}</h5>
                <p>Instructor</p>
              </div>
            </div>
            <hr className="kz_hr_line" />
            <div className="row m-0 kz_accountant_detail">
              <div className="col-lg-6 col-md-6 after_vr_line position-relative kz_col_left">
                <div className="form-group">
                  <label className="kz_label">Email</label>
                  <p className="kz_input_data">{instructor?.email || "N/A"}</p>
                </div>
                <hr className="kz_hr_line" />
                <div className="form-group">
                  <label className="kz_label">Status</label>
                  <p className={`kz_input_data ${showCancelMessage ? "cancel_status" : "active_status"}`}>
                    {showCancelMessage ? "Cancel" : "Active"}
                  </p>
                </div>
                <hr className="kz_hr_line" />
                <div className="form-group">
                  <label className="kz_label">Start Date & Time</label>
                  <p className="kz_input_data">
                    {convertDateFormat(bookingDescription?.data?.start)}
                  </p>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 kz_col_right">
                <div className="form-group">
                  <label className="kz_label">Phone</label>
                  <p className="kz_input_data">{instructor?.phone || "N/A"}</p>
                </div>
                <hr className="kz_hr_line" />
                <div className="form-group">
                  <label className="kz_label">Gender</label>
                  <p className="kz_input_data">{instructor?.gender || "N/A"}</p>
                </div>
                <hr className="kz_hr_line" />
                <div className="form-group">
                  <label className="kz_label">End Date & Time</label>
                  <p className="kz_input_data">
                    {convertDateFormat(bookingDescription?.data?.end)}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Package Details */}
          <div className="bg-transparent">
            <div className="acc_title">
              <h5 className="heading_booking_details mt-3">Package Details</h5>
              <hr className="kz_hr_line" />
              <div className="d-flex align-items-center payment_content ms-3">
                <p>{packageData?.sub_service?.service?.name}</p>
              </div>
              <div className="d-flex align-items-center payment_content ms-3">
                <p>Time-Duration : {packageData?.time} min</p>
              </div>
              <div className="d-flex align-items-center payment_content ms-3 mb-0">
                <p>Package Amount : {packageData?.amount}$</p>
              </div>
            </div>
          </div>

          {/* Pickup Location */}
          <div className="bg-transparent">
            <div className="acc_title">
              <h5 className="heading_booking_details mt-3">Pickup Location</h5>
              <hr className="kz_hr_line" />
              <div className="row m-0 kz_accountant_detail">
                <div className="col-lg-12 col-md-12 kz_col_left">
                  <div className="form-group">
                    <label className="kz_label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value={
                              bookingDescription?.data
                                ? bookingDescription.data.pickup_location ?? ""
                                : ""
                            }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Info */}
          <div className="bg-gray">
            <div className="payment_title">
              <h5 className="heading_booking_details mt-3">Payment</h5>
            </div>
            <hr className="kz_hr_line" />
            <div className="d-flex align-items-center payment_content ms-2 text-indigo mt-3">
              <h4>
                Payment Type:{" "}
                <span className="text-capitalize">{bookingDescription?.data?.payment_type}</span>
              </h4>
            </div>
            <div className="d-flex align-items-center payment_content ms-2 mt-3 text-indigo">
              <h4>Total: ${packageData?.amount}</h4>
            </div>
          </div>
        </div>

        {/* Cancel Modal */}
        <Modal
          size="sm"
          show={smShow}
          onHide={() => setSmShow(false)}
          className="booking_cancel_modal"
          aria-labelledby="example-modal-sizes-title-sm"
          centered
        >
          <Modal.Header closeButton className="border-0">
            <Modal.Title id="example-modal-sizes-title-sm" />
          </Modal.Header>
          <Modal.Body>
            <h6 className="text-center">Confirm booking cancellation?</h6>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button onClick={bookingCancelConfirm} className="bg-indigo">
              Confirm
            </Button>
            <Button onClick={() => setSmShow(false)} className="btn-danger">
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </section>
  );
};
